import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';

export interface SearchBarState {
  [key: string]: {
    tableValueToSearch: string;
    graphValueToSearch: string;
  };
}

const initialState: SearchBarState = {
  reports: {
    tableValueToSearch: '',
    graphValueToSearch: ''
  }
};

const searchBarSlice = createSlice({
  name: 'searchBar',
  initialState,
  reducers: {
    applySearchToTable: (
      state,
      {
        payload: { id, valueToSearch }
      }: PayloadAction<{ id: string; valueToSearch: string }>
    ) => {
      if (Object.hasOwnProperty.call(state, id)) {
        state[id].tableValueToSearch = valueToSearch;
      } else {
        state[id] = {
          tableValueToSearch: valueToSearch,
          graphValueToSearch: ''
        };
      }
    },
    applySearchToGraph: (
      state,
      {
        payload: { id, valueToSearch }
      }: PayloadAction<{ id: string; valueToSearch: string }>
    ) => {
      if (Object.hasOwnProperty.call(state, id)) {
        state[id].graphValueToSearch = valueToSearch;
      } else {
        state[id] = {
          tableValueToSearch: '',
          graphValueToSearch: valueToSearch
        };
      }
    },
    applySearchToTableAndGraph: (
      state,
      {
        payload: { id, valueToSearch }
      }: PayloadAction<{ id: string; valueToSearch: string }>
    ) => {
      state[id] = {
        tableValueToSearch: valueToSearch,
        graphValueToSearch: valueToSearch
      };
    },
    clearSearch: (
      state,
      { payload: { id } }: PayloadAction<{ id: string }>
    ) => {
      state[id] = {
        tableValueToSearch: '',
        graphValueToSearch: ''
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const selectSelf = (state: RootState) => state.searchBar;
const selectId = (state: RootState, id: string) => id;
export const getSearchTermsById = createSelector(
  selectSelf,
  selectId,
  (state, id) => {
    if (id === undefined || !Object.hasOwnProperty.call(state, id)) {
      return {
        tableValueToSearch: '',
        graphValueToSearch: ''
      };
    }

    return state[id];
  }
);

const { reducer, actions } = searchBarSlice;

export const {
  applySearchToTable,
  applySearchToGraph,
  applySearchToTableAndGraph,
  clearSearch
} = actions;

export default reducer;
